export const extractRowIndexAndColumnName = (
  name: `${string}.${number}` | `${string}.${number}.${string}`
): { fieldName: string; dataIndex: number; columnName?: string } => {
  const fieldPath = name.split('.');

  if (fieldPath.length < 2) {
    throw new Error(
      `Expecting form table field name to have at least two dot-notated parts (e.g. "data.0.columnName") but got ${name}`
    );
  }

  const last = fieldPath.pop();
  let dataIndex: number;
  let columnName: string | undefined;

  if (!isNaN(Number(last))) {
    dataIndex = Number(last);
  } else {
    dataIndex = Number(fieldPath.pop()!);
    columnName = last!;

    if (isNaN(dataIndex)) {
      throw new Error(
        `Expecting form table field name to have a number (row index) as the last or second-to-last part (e.g. "data.0.columnName") but got ${name}`
      );
    }
  }

  return { fieldName: fieldPath.join('.'), dataIndex, columnName };
};
